import {match} from 'ts-pattern';

import {type OnlineOfferScrollDepthMilestone} from '../api/types/onlineOfferTypes';

const FULL_SCROLL_DEPTH_PERCENT = 100;
const THREE_QUARTERS_SCROLL_DEPTH_PERCENT = 75;
const HALF_SCROLL_DEPTH_PERCENT = 50;
const QUARTER_SCROLL_DEPTH_PERCENT = 25;
const INITIAL_SCROLL_DEPTH_PERCENT = 0;

export const computeScrollDepthMilestone = (): OnlineOfferScrollDepthMilestone => {
  const scrollHeight = document.documentElement.scrollHeight;
  const viewportHeight = window.innerHeight;
  const visibleBottom = window.scrollY + viewportHeight;

  if (scrollHeight <= viewportHeight || Math.ceil(visibleBottom) >= scrollHeight) {
    return FULL_SCROLL_DEPTH_PERCENT;
  }

  const percent = (visibleBottom / scrollHeight) * FULL_SCROLL_DEPTH_PERCENT;

  return match<number, OnlineOfferScrollDepthMilestone>(percent)
    .when(
      (value) => value >= FULL_SCROLL_DEPTH_PERCENT,
      () => FULL_SCROLL_DEPTH_PERCENT
    )
    .when(
      (value) => value >= THREE_QUARTERS_SCROLL_DEPTH_PERCENT,
      () => THREE_QUARTERS_SCROLL_DEPTH_PERCENT
    )
    .when(
      (value) => value >= HALF_SCROLL_DEPTH_PERCENT,
      () => HALF_SCROLL_DEPTH_PERCENT
    )
    .when(
      (value) => value >= QUARTER_SCROLL_DEPTH_PERCENT,
      () => QUARTER_SCROLL_DEPTH_PERCENT
    )
    .otherwise(() => INITIAL_SCROLL_DEPTH_PERCENT);
};
